const styles = {
  container: {
    backgroundColor: "#FFD282",
    padding: "16px",
  },
  title: {
    fontSize: "16px",
    fontWeight: "bold",
    color: "#231f20",
    margin: "0 0 8px 0",
  },
  message: {
    fontSize: "14px",
    color: "#231f20",
    margin: "0",
    lineHeight: "1.5",
  },
};

const InfoBanner = ({ title, message, style, className }) => {
  if (!title && !message) return null;

  return (
    <div className={className} style={{ ...styles.container, ...style }}>
      {title && <p style={styles.title}>{title}</p>}
      {message && <p style={styles.message}>{message}</p>}
    </div>
  );
};

export default InfoBanner;
